import { render, staticRenderFns } from "./UserTaskDateGroup.vue?vue&type=template&id=081e9378&"
import script from "./UserTaskDateGroup.vue?vue&type=script&lang=js&"
export * from "./UserTaskDateGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VDivider,VVirtualScroll})
